import { Flex, IconButton, IconNoteSolid, Tooltip } from '@smarterservices/smarter-ui';

/**
 * TransferNote Component
 * 
 * Displays a transfer note indicator icon with a tooltip showing the note content.
 * Only renders if a note is present.
 * 
 * @param {Object} props
 * @param {string} [props.note] - The transfer note content to display in the tooltip
 * @returns {JSX.Element|null} The transfer note icon or null if no note
 */
function TransferNote({ note }) {
    if (!note) {
        return null;
    }

    return (
        <Flex.Item>
            <Tooltip
                renderTip={note}
                placement="top"
                mountNode={() => document.body}
            >
                <span>
                    <IconButton
                        screenReaderLabel="Transfer Note"
                        withBackground={false}
                        withBorder={false}
                        color="danger"
                        readOnly
                        size="small"
                    >
                        <IconNoteSolid />
                    </IconButton>
                </span>
            </Tooltip>
        </Flex.Item>
    );
}

export default TransferNote;
